import { BorderStyle } from '../react-table';

export const borderStyleToString = (
  borderStyle: BorderStyle | undefined,
  direction: '' | 'top' | 'right' | 'bottom' | 'left' = '',
): string | undefined => {
  if (borderStyle === undefined) {
    return;
  }

  const directionPostfix = direction && `-${direction}`;
  return `${
    borderStyle.width
      ? `border${directionPostfix}-width: ${borderStyle.width};`
      : ''
  }${
    borderStyle.style
      ? `border${directionPostfix}-style: ${borderStyle.style};`
      : ''
  }${
    borderStyle.color
      ? `border${directionPostfix}-color: ${borderStyle.color};`
      : ''
  }`;
};
